import { computed, Ref, ref } from 'vue';
import { PortalType } from '@studyportals/domain-client';

import getters from '@/study-search/store/getters';
import { IFaq } from '@/study-search/interfaces';
import { FaqBuilder } from '@/study-search/models/faq';

export default class Faq {
	public faqs: Ref<IFaq[]> = ref([]);
	private readonly faqBuilder: FaqBuilder;

	constructor() {
		this.faqBuilder = new FaqBuilder();
	}

	public async mounted(): Promise<void> {
		if (!this.isPortalTypeMasters.value) {
			return;
		}

		await this.buildFaqs();
	}

	public isPortalTypeMasters = computed(() => getters.getPortalType() === PortalType.MASTER);

	public async buildFaqs(): Promise<void> {
		this.faqs.value = await this.faqBuilder.build();
	}

	public isFaqsEmpty = computed(() => this.faqs.value.length === 0);
}
